import React from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import { formatDate1122 } from "../../../../CloudStorage/CommonFunction";

const Weeks = ({ setFirstdate, setLastdate }) => {
  const handleDatesSet = (arg) => {
    const firstDate = arg.start;
    const lastDate = new Date(arg.end); 
    lastDate.setDate(lastDate.getDate() - 1); 

    if (setFirstdate) setFirstdate(formatDate1122(firstDate));
    if (setLastdate) setLastdate(formatDate1122(lastDate));
  };

  return (
    <div style={{ position: "relative" }}>
      <FullCalendar
        plugins={[timeGridPlugin]}
        headerToolbar={{
          left: "prev",
          center: "title",
          right: "next",
        }}
        initialView="timeGridWeek"
        events={[]}
        datesSet={handleDatesSet}
      />
      <style>
        {`
          .fc-view {
            display: none;
          }
        `}
      </style>
    </div>
  );
};

export default Weeks;
